import Vue from "vue";
import VueRouter from 'vue-router';

Vue.use(VueRouter)

import home  from './vues/Home.vue'


// 2. Define some routes
const routes = [
    { path: '/', component: home },
]

export const router = new VueRouter({
    routes: routes,
    mode: 'history'
})
